import {
    GET_NO_OF_DOORS,
    SET_NO_OF_DOORS
} from "./NoOfDoorsType"

const getNoOfDoors = (val : any) => ({
    type: GET_NO_OF_DOORS,
    val
});

const setNoOfDoors = (noOfDoorsDropDown: any) => ({
    type: SET_NO_OF_DOORS,
    noOfDoorsDropDown: noOfDoorsDropDown
});

export {
    getNoOfDoors,
    setNoOfDoors
}
